<template>
  <LoadingState v-if="status.isLoading" />
  <ErrorState v-else-if="status.isErrored" />
  <div v-else-if="(status.isLoaded || status.isUpdating) && malwareScans" class="row">
    <div class="col-md-4">
      <Card :title="$t('global.malware-scans')" :height100="false" class="mb-4">
        <CardTabledList :items="getScansSummary()" />
      </Card>
    </div>
    <div class="col-md-8">
      <MagentoMalwareScansTable :hits="getHits()" :service="service" :status="status" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import ErrorState from "@/components/display/ItemErrorState";
import LoadingState from "@/components/display/LoadingState";
import MagentoMalwareScansTable from "@/components/smart/tables/MagentoMalwareScansTable";
import store from "@/store";

export default {
  name: "SafeHarborMalwareScansPage",
  components: {
    Card,
    CardTabledList,
    ErrorState,
    LoadingState,
    MagentoMalwareScansTable,
  },
  setup(props, { root }) {
    const malwareScans = computed(() => store.getters["safeHarbor/getMalwareScans"]);
    const service = computed(() => store.getters["sharedHosts/getItem"]);
    const status = computed(() => store.getters["safeHarbor/getMalwareScansStatus"]);

    const getHits = () => malwareScans.value?.hits;
    const getScansSummary = () => [
      {
        key: root.$t("global.total-files-scanned"),
        value: malwareScans.value?.scannedFiles,
      },
      {
        key: root.$t("global.files-impacted"),
        value: getHits()?.length,
      },
    ];

    onMounted(() => {
      store.dispatch("safeHarbor/getMalwareScans", service.value.id);
    });

    return {
      getHits,
      getScansSummary,
      malwareScans,
      service,
      status,
    };
  },
};
</script>
